import React from 'react';
import { styled } from '@mui/material/styles';

// new designer made icons
import Ticket from 'assets/images/icons/ticket.svg';
import Workflow from 'assets/images/icons/workflow.svg';
import Calendar from 'assets/images/icons/calendar.svg';
import CalendarOverdue from 'assets/images/icons/calendar_overdue.svg';

const iconMap = { Ticket, Workflow, Calendar, CalendarOverdue };

const StyledIcon = styled('img')({
  width: '3rem',
  height: '3rem',
  objectFit: 'contain',
});

const Icon = ({ icon: iconName }) => {
  const mappedIcon = iconMap[iconName];
  if (!mappedIcon) return null;

  return <StyledIcon src={mappedIcon} alt={`${iconName} icon`} />;
};

export default Icon;
